import { AJV_OPTIONS, configureAjv } from './';

export const compileSchema = (schema, args = {}, extendAjv = () => null) => {
  const ajv = configureAjv(AJV_OPTIONS);

  extendAjv(ajv, args);

  return ajv.compile(schema);
};
